import { Dialog, DialogFooter } from '@fluentui/react';
import * as React from 'react';
import { AuthProvider } from '../../services';
import { SalusPrimaryButton } from '../shared/SalusPrimaryButton';

export const Unauthorized: React.FunctionComponent = () => {
  return (
    <div className="fixed-top w-100 h-100 bg-light">
      <Dialog
        hidden={false}
        dialogContentProps={{
          title: 'Unauthorized',
          subText: 'You do not have permission to view this application.'
        }}
        modalProps={{
          overlay: {
            isDarkThemed: true
          }
        }}
        styles={{ root: { selectors: { '.ms-Overlay--dark': { marginTop: 0 } } } }}
      >
        <DialogFooter>
          <SalusPrimaryButton onClick={(): void => AuthProvider.logout()} text="Sign Out" />
        </DialogFooter>
      </Dialog>
    </div>
  );
};
